import clsx from 'clsx'
import { Button, Container, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import styles from 'modules/Statistics/statistics.module.scss'

const StatisticsLayout = ({
  ChartComponent,
  TableComponent,
  BreadcrumbsComponent = null,
  FilterPanel = null,
}) => {
  const [cfg, setCfg] = useLocalStorage('statisticsConfig', {
    showStatisticsChart: true,
  })
  const [chartVisible, setChartVisible] = useState(cfg.showStatisticsChart)
  const { t } = useTranslation(['statistics'])
  const tableContainerRef = useRef()

  useEffect(() => {
    setCfg({ showStatisticsChart: chartVisible })
  }, [chartVisible])

  return (
    <>
      <div className={'margin-bottom-32'}>
        {BreadcrumbsComponent && (
          <div className={styles['breadcrumbs-panel']}>
            {BreadcrumbsComponent}
          </div>
        )}
        {FilterPanel}
      </div>

      <div className={styles['chart-components']}>
        <div
          className={clsx(styles['chart-wrapper'], {
            [styles['chart-wrapper_hidden']]: !chartVisible,
          })}
        >
          {ChartComponent}
        </div>
        <Container
          display={'flex'}
          flexJustify={'flex-end'}
          className={styles['hide-chart-button-wrapper']}
        >
          <Button
            onClick={() => setChartVisible(!chartVisible)}
            className={styles['hide-chart-button']}
            variant={'link'}
            size={'s'}
            color={'text-primary'}
            startIcon={<Icon name={'views'} color={'inherit'} />}
          >
            {t('filters.chart_visiblity', {
              context: chartVisible ? 'hide' : 'show',
            })}
          </Button>
        </Container>
      </div>

      <div className={styles['table-container']} ref={tableContainerRef}>
        {TableComponent}
      </div>
    </>
  )
}

StatisticsLayout.propTypes = {
  drawerState: PropTypes.bool,
  ChartComponent: PropTypes.element,
  TableComponent: PropTypes.element,
  BreadcrumbsComponent: PropTypes.element,
  FilterPanel: PropTypes.element,
}

export default StatisticsLayout
